import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actions from '../../actions';
import { DOWNLOAD_TYPE_OPTIONS, PARSE_TYPE_OPTIONS } from '../../constants/FeedOptions';
import { Form, FormControl, Input, Dropdown, Button, Pane, Switch, Alert } from '../../components';

const initialState = {
	feed: {
		downloadType: DOWNLOAD_TYPE_OPTIONS[0].value,
		parseType: PARSE_TYPE_OPTIONS[0].value,
		isEnabled: true,
	},
	isEditing: false,
	feedNameErrorMessage: '',
};

export class EditFeedPane extends Pane {
	constructor(props) {
		super(props);

		this.state = _.clone(initialState);
		if (props.feed) {
			this.state.feed = props.feed;
		}
	}

	componentWillReceiveProps(nextProps) {
		// If the feed was saved then close the pane
		if (!this.props.isSaved && nextProps.isSaved) {
			this.close();

			// Show corporation link pane after saving new feed and closing
			if (!this.props.feed && !nextProps.feed) {
				const feed = _.clone(this.state.feed);
				setTimeout(() => this.props.onNewFeed(feed), 300);
			}
		}

		if (!this.state.isEditing) {
			this.setState({ feed: nextProps.feed || initialState.feed });
		}
	}

	close() {
		this.setState(initialState, () => {
			this.props.actions.clearFeedError();
			super.close();
		});
	}

	handleSubmitForm(e) {
		e.preventDefault();
		const feedNameRegex = /^(?![\s\W]+$).+$/;
		const { name } = this.state.feed || {};

		if (name && !feedNameRegex.test(name)) {
			this.props.actions.clearFeedError();
			this.setState({ feedNameErrorMessage: 'Please enter valid feed name' });
			return;
		}
		this.setState({ feedNameErrorMessage: '' });

		if (this.state.feed.id) {
			this.props.actions.editFeed(this.state.feed);
		} else {
			this.props.actions.addFeed(this.state.feed);
		}
	}

	setData(data) {
		// Set the new feed data
		let feed = _.assign({}, this.state.feed, data);

		this.setState({ isEditing: true, feed });
	}

	renderContent() {
		let errors = this.props.error && this.props.error.errors ? this.props.error.errors : {};

		return (
			<Form onSubmit={e => this.handleSubmitForm(e)}>
				<FormControl hasError={'name' in errors}>
					<label>Feed Name</label>
					<Input
						name="name"
						value={this.state.feed.name}
						onChange={e => this.setData({ name: e.target.value })}
					/>
					<If condition={'name' in errors || this.state.feedNameErrorMessage}>
						<Alert type="tooltip" style="error">
							{errors.name || this.state.feedNameErrorMessage}
						</Alert>
					</If>
				</FormControl>

				<FormControl hasError={'source' in errors}>
					<label>Source</label>
					<Input
						name="source"
						value={this.state.feed.source}
						onChange={e => this.setData({ source: e.target.value })}
					/>
					<If condition={'source' in errors}>
						<Alert type="tooltip" style="error">
							{errors.source}
						</Alert>
					</If>
				</FormControl>

				<FormControl hasError={'downloadType' in errors}>
					<label>Download Type</label>
					<Dropdown
						name="downloadType"
						options={DOWNLOAD_TYPE_OPTIONS}
						selected={this.state.feed.downloadType}
						onChange={downloadType => this.setData({ downloadType })}
					/>
					<If condition={'downloadType' in errors}>
						<Alert type="tooltip" style="error">
							{errors.downloadType}
						</Alert>
					</If>
				</FormControl>

				<FormControl hasError={'parseType' in errors}>
					<label>Parse Type</label>
					<Dropdown
						name="parseType"
						options={PARSE_TYPE_OPTIONS}
						selected={this.state.feed.parseType}
						onChange={parseType => this.setData({ parseType })}
					/>
					<If condition={'parseType' in errors}>
						<Alert type="tooltip" style="error">
							{errors.parseType}
						</Alert>
					</If>
				</FormControl>

				<FormControl hasError={'isEnabled' in errors}>
					<label>Enabled</label>
					<Switch
						type="active-inactive"
						name="isEnabled"
						defaultChecked={this.state.feed.isEnabled}
						onChange={e => this.setData({ isEnabled: !this.state.feed.isEnabled })}
					/>
					<If condition={'isEnabled' in errors}>
						<Alert type="tooltip" style="error">
							{errors.isEnabled}
						</Alert>
					</If>
				</FormControl>

				<Button
					type="submit"
					size="small"
					className="pull-right"
					disabled={this.props.isSaving}>
					{this.props.isSaving ? 'Saving...' : 'Save'}
				</Button>
			</Form>
		);
	}
}

export default connect(
	state => ({
		isAdmin: state.auth.user.isAdmin,
		isSaving: state.feeds.isSaving,
		isSaved: state.feeds.isSaved,
		error: state.feeds.error,
	}),
	dispatch => ({
		actions: bindActionCreators(actions.feeds, dispatch),
	}),
)(EditFeedPane);



// WEBPACK FOOTER //
// ./src/assets/js/containers/feeds/AddEditPane.js